import React, { Component } from "react";

import "./List.less";

export default class List extends Component {
  render() {
    const style = {
      ...this.props.style,
      width: this.props.width,
    };
    return (
      <div
        className={"nano-panel-list " + (this.props.className || "")}
        style={style}
      >
        {this.props.children}
      </div>
    );
  };
}
